export const PURPLE = "#7C6BD9";
export const MINT = "#5BC2B2";

export function hexToRgba(hex, a = 1) {
  const h = hex.replace("#", "");
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r},${g},${b},${a})`;
}

export function mix(hex, white = 0.85) {
  const h = hex.replace("#", "");
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  const m = (c) => Math.round(c + (255 - c) * white);
  return `rgb(${m(r)},${m(g)},${m(b)})`;
}
